module.exports = __webpack_public_path__ + "static/media/recycling-center.b4f44f8e.svg";